module.exports = "/images/vendor/tui-image-editor/dist/svg/icon-d.svg?597bad21c7aa9eabf14f2721d2a1d931";